import { render, staticRenderFns } from "./MonthlyTransactions.vue?vue&type=template&id=6fa34bcc"
import script from "./MonthlyTransactions.vue?vue&type=script&lang=js"
export * from "./MonthlyTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports